import * as React from 'react';
import displayCurrencyNumber from '../utils/displayCurrencyNumber';
import calculateResults from '../utils/calculateResults';
import { ResultsProps } from '../types';
import { useFormContext } from './contexts/form';
import Loading from '../widgets/Loading';

const Results: React.FC<ResultsProps> = ({
	resultHeadings,
	formData,
	showResults,
	calculatorKey,
}) => {
	const tableRef = React.useRef<HTMLTableElement | null>(null);
	const [loadingHeight, setLoadingHeight] = React.useState<number | null>(null);
	const { loading } = useFormContext();

	const hasNaNOrNull = (data: { [key: string]: number | object | null | undefined }): boolean => {
		return Object.values(data).some((value) => {
			return value === null || Number.isNaN(value);
		});
	};

	React.useEffect(() => {
		if (tableRef.current) {
			setLoadingHeight(tableRef.current.offsetHeight);
		}
	}, []);

	return (
		<Loading isLoading={loading} height={loadingHeight}>
			<table className="app-calculator__results" ref={tableRef}>
				<tbody className="app-calculator__results-body">
					{resultHeadings.map((heading: string, index: number) => {
						let result = calculateResults(index, formData, calculatorKey);
						if ('number' !== typeof result) {
							result = 0;
						}

						const formattedResult = displayCurrencyNumber(result, 0);
						return (
							<tr key={index} className="app-calculator__result">
								<td
									className={`app-calculator__result-label ${
										!showResults ? 'app-calculator__result-label--disabled' : ''
									}`}
								>
									{heading}
								</td>
								<td
									className={`app-calculator__result-value ${
										!showResults ? 'app-calculator__result-value--disabled' : ''
									}`}
								>
									{hasNaNOrNull(formData) ? '---' : `$${formattedResult}`}
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</Loading>
	);
};

export default Results;
